import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import VideoCard from '../components/VideoCard';
import './Home.css';

function Home() {
  const { isAuthenticated, user } = useAuth();
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
  if (!isAuthenticated) {
    setLoading(false);
    return;
  }
  fetchVideos();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [isAuthenticated]);

  const fetchVideos = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/videos');
      setVideos(response.data);
      setError(null);
    } catch (err) {
      setError('Failed to load videos. Please try again later.');
      console.error('Error fetching videos:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
}

if (!isAuthenticated) {
    return (
      <div className="home welcome-home">
        <div className="welcome-hero">
          <h1>WELCOME TO DMSHORTFILMS</h1>
          <p>
            Discover and share curated short films. 
            Create a channel to upload your own videos and set private screenings.
          </p>
          <p>
            The primary focus is to provide a dedicated platform for “Hot Short Films” creators who have been sidelined by YouTube, while strictly enforcing a no-nudity policy.
          </p>
          <div className="welcome-actions">
            <a href="/register" className="btn btn-primary">Register to view content</a>
            <a href="/login" className="btn btn-secondary">Login</a>
          </div>
        </div>
        <div className="welcome-info">
          <h2>How it works</h2>
          <ul>
            <li>Create an account to access the catalog.</li>
            <li>Create a channel to upload and manage your short films.</li>
            <li>Mark videos as public or private and manage pricing.</li>
          </ul>
        </div>
      </div>
    );
}

if (error) {
  return (
    <div className="error-container">
      <p>{error}</p>
      <button className="btn btn-primary" onClick={fetchVideos}>
        Retry
      </button>
    </div>
  );
}

return (
  <div className="home">
    <div className="video-grid">
      {videos.map((video) => (
        <VideoCard key={video._id} video={video} />
      ))}
    </div>
  </div>
);
}

export default Home;
